export default __webpack_public_path__ + "static/media/ausdc.9bd4364f.svg";